class FeaturedCollectionsTabs extends HTMLElement {
    connectedCallback() {
        this.track = this.querySelector('.featured-collections-tabs__track');
        this.indicator = this.querySelector('.featured-collections-tabs__indicator');
        this.inputs = this.querySelectorAll('.featured-collections-tabs__input');

        this.updateIndicator = this.updateIndicator.bind(this);
        this.handleResize = this.updateIndicator;

        this.inputs.forEach((input) => input.addEventListener('change', this.updateIndicator));
        window.addEventListener('resize', this.handleResize);

        this.inner = this.querySelector('.featured-collections-tabs__inner');
        if (this.inner) {
        this.resizeObserver = new ResizeObserver(this.updateIndicator);
        this.resizeObserver.observe(this.inner);
        }

        this.updateIndicator();
        this.classList.add('featured-collections-tabs--indicator-ready');
        requestAnimationFrame(() => this.classList.add('featured-collections-tabs--indicator-animate'));
    }
  
    disconnectedCallback() {
        this.inputs.forEach((input) => input.removeEventListener('change', this.updateIndicator));
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  
    updateIndicator() {
        const checked = this.querySelector('.featured-collections-tabs__input:checked');
        if (!checked) return;

        const panelId = checked.getAttribute('aria-controls');
        if (panelId) {
            this.querySelectorAll('.featured-collections-tabs__panel').forEach((panel) => {
            panel.hidden = panel.id !== panelId;
            });
        }

        if (!this.indicator || !this.track) return;

        const label = checked.nextElementSibling;
        if (!label?.classList.contains('featured-collections-tabs__button')) return;

        const trackRect = this.track.getBoundingClientRect();
        const labelRect = label.getBoundingClientRect();

        this.indicator.style.width = `${labelRect.width}px`;
        this.indicator.style.transform = `translateX(${labelRect.left - trackRect.left}px)`;
    }
}
  
if (!customElements.get('featured-collections-tabs')) {
    customElements.define('featured-collections-tabs', FeaturedCollectionsTabs);
}